import React, { PureComponent, Fragment } from "react";
import _ from 'lodash';
import styled from "styled-components";
import TrackVisibility from "react-on-screen";
import { parse, format } from "date-fns";
import * as ENUMS from "../../enums/enums";
import * as COLOURS from "../../enums/colours";
import * as SIZES from "../../enums/sizes";

class Card extends PureComponent {
  state = {
    frameOpen: false
  };

  currentLang = () => {
    return document.getElementsByTagName("html")[0].getAttribute("lang") ===
      "en"
      ? "uk"
      : "us";
  };

  calcWidth = width => {
    switch (width) {
      case 2:
        return "span-4";
      case 3:
        return "span-6";
      case 4:
        return "span-8";
      default:
        return "span-12";
    }
  };

  calcImageStyle = width => {
    switch (width) {
      case 2:
        return "hub_1_col";
      case 3:
        return "hub_2_col";
      case 4:
        return "hub_2_col";
      default:
        return "hub_3_col";
    }
  };

  formatDate = string => {
    if (this.currentLang() === "uk") {
      return format(parse(string), "DD MMMM YYYY");
    }

    return format(parse(string), "MMMM DD YYYY");
  };

  toggleFrame = () => {
    this.setState({ frameOpen: !this.state.frameOpen });
  };

  ensureUKLanguagePrefix = link => {
    if (_.startsWith(link, 'https://www.womblebonddickinson.com/us/')) {
      return `/uk/${link.replace('https://www.womblebonddickinson.com/us/', '')}`;
    }

    if (_.startsWith(link, '/us/')) {
      return `/uk/${link.replace('/us/', '')}`;
    }

    if (_.startsWith(link, '/')) {
      return `/uk${link}`;
    }

    return link;
  };

  ensureUSLanguagePrefix = link => {
    if (_.startsWith(link, 'https://www.womblebonddickinson.com/uk/')) {
      return `/us/${link.replace('https://www.womblebonddickinson.com/uk/','')}`;
    }

    if (_.startsWith(link, '/uk/')) {
      return `/us/${link.replace('/uk/', '')}`;
    }

    if (_.startsWith(link, '/')) {
      return `/us${link}`;
    }

    return link;
  };

  processInsightLink = link => {
    const currentLang = this.currentLang();

    if (!_.startsWith(link, "/") && !_.startsWith(link, 'https://www.womblebonddickinson.com/')) {
      console.log(link);
      return link;
    }

    if (currentLang === "uk") {
      return this.ensureUKLanguagePrefix(link);
    }

    return this.ensureUSLanguagePrefix(link);
  };

  render() {
    const {
      item,
      item: { insight },
      filtering,
      jsonMedia
    } = this.props;
    let tagBackground = COLOURS.darkGrey;
    if (ENUMS.DEFAULT_CARD_TAGS[insight.tag]) {
      tagBackground = ENUMS.DEFAULT_CARD_TAGS[insight.tag];
    }
    return (
      <CardWrapper className={filtering ? `span-4` : this.calcWidth(item.w)}>
        {insight.insightType === "CUSTOM_FORM" &&
          insight.image &&
          insight.image.thumb_image &&
          jsonMedia[insight.image.mid] && (
            <CardImage
              href={this.processInsightLink(insight.link)}
              target="_blank"
              style={{
                backgroundImage: `url('${
                  jsonMedia[insight.image.mid][this.calcImageStyle(item.w)]
                }')`
              }}
            />
          )}

        {insight.insightType === "CTA_FORM" && (
          <IframeContainer href={this.processInsightLink(insight.link)} target="_blank">
            <IframeSummaryContainer>
              {insight.title && (
                <h3 className="font--semibold">{insight.title}</h3>
              )}
              {insight.summary && (
                <div dangerouslySetInnerHTML={{ __html: insight.summary }} />
              )}
            </IframeSummaryContainer>
            <iframe
              src={`/webform/${insight.machineName}/share`}
              frameborder="0"
              title="Form | Womble Bond Dickinson"
              style={{
                width: "calc(50% - 1px)",
                height: "100%",
                backgroundColor: "#ffffff",
                minHeight: "25rem"
              }}
            />
          </IframeContainer>
        )}

        {insight.insightType === "NODE_FORM" && insight.nodeBannerImageUrl && (
          <CardImage
            href={insight.nodeUrl}
            target="_blank"
            style={{
              backgroundImage: `url('${insight.nodeBannerImageUrl}')`
            }}
          />
        )}

        {insight.insightType === "VIDEO_FORM" && (
          <CardIFrame>
            <iframe
              src={insight.youtubeVideo}
              frameborder="0"
              style={{ height: "100%", width: "100%" }}
              title="Video"
            />
          </CardIFrame>
        )}

        {insight.insightType === "COUNTER_FORM" && (
          <CardCounter insight={insight} />
        )}

        {insight.insightType === "RELATED_CONTENT_FORM" && (
          <CardRelated insight={insight} processInsightLink={this.processInsightLink} />
        )}

        {insight.title && insight.insightType !== "CTA_FORM" && (
          <CardTitleOutput
            link={this.processInsightLink(insight.link) || insight.nodeUrl || false}
            title={insight.title}
          />
        )}

        {insight.summary && insight.insightType !== "CTA_FORM" && (
          <CardSummary dangerouslySetInnerHTML={{ __html: insight.summary }} />
        )}

        <CardBase>
          {insight.tag && (
            <CardTag style={{ backgroundColor: tagBackground }}>
              {insight.tag}
            </CardTag>
          )}
          {insight.date && <CardDate>{this.formatDate(insight.date)}</CardDate>}
          {insight.link && <CardLink link={this.processInsightLink(insight.link)} />}
          {insight.nodeUrl && <CardLink link={insight.nodeUrl} />}
        </CardBase>
      </CardWrapper>
    );
  }
}

const CardTitleOutput = props => (
  <CardTitle className="font--semibold">
    {props.link && (
      <a href={props.link} target="_blank">
        {props.title}
      </a>
    )}
    {!props.link && `${props.title}`}
  </CardTitle>
);

const CardLink = ({ link }) => {
  return (
    <a href={link} target="_blank">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="wbdi fg--yellow sz--md"
        style={{ display: "block" }}
      >
        <use xlinkHref="/themes/custom/wbd/assets/svg/defs.svg#link-arrow" />
      </svg>
    </a>
  );
};

const CardCounter = ({ insight }) => {
  return (
    <CardCounterWrapper>
      <CardCounterRow>
        {insight.iconA && <CardCounterIcon icon={insight.iconA} />}
        <CardCounterDetail>
          <h3
            className="font--regular font--db fg--white mb--0"
            style={{ width: "100%" }}
          >
            {insight.topTitle}
          </h3>
          <h4
            className="font--regular font--sm fg--white mb--0"
            style={{ marginTop: ".5rem" }}
          >
            {insight.topSubTitle}
          </h4>
        </CardCounterDetail>
      </CardCounterRow>

      <CardCounterRow>
        {insight.iconB && <CardCounterIcon icon={insight.iconB} />}
        <CardCounterDetail>
          <TrackVisibility>
            <CardCounterElement
              counterRange={{
                from: insight.from,
                to: insight.to,
                prefix: insight.prefix,
                suffix: insight.suffix
              }}
            />
          </TrackVisibility>
          <h4
            className="font--regular font--sm fg--white mb--0"
            style={{ marginTop: ".5rem" }}
          >
            {insight.subTitle}
          </h4>
        </CardCounterDetail>
      </CardCounterRow>
    </CardCounterWrapper>
  );
};

const CardCounterIcon = ({ icon }) => (
  <img
    src={icon.fieldImage.url}
    alt={icon.entityLabel}
    width="80"
    height="80"
  />
);

class CardCounterElement extends PureComponent {
  componentDidMount() {
    const { counterRange, isVisible } = this.props;
    this.spinCounter(counterRange, isVisible);
  }

  componentWillReceiveProps(nextProps) {
    const { counterRange, isVisible } = nextProps;
    this.spinCounter(counterRange, isVisible);
  }

  spinCounter = (counterRange, isVisible) => {
    if (counterRange && isVisible) {
      let od = new window.Odometer({
        el: this.odometer,
        value: parseInt(counterRange.from, 10),
        theme: "minimal"
      });
      setTimeout(() => {
        od.update(parseInt(counterRange.to, 10));
      }, 100);
    } else if (counterRange && !isVisible) {
      this.odometer.innerHTML = parseInt(counterRange.from, 10);
    }
  };

  render() {
    const { prefix, from, suffix } = this.props.counterRange;
    return (
      <h3
        className="font--regular font--lg fg--white mb--0"
        style={{ width: "100%" }}
      >
        {prefix && prefix}
        <span className="font--semibold" ref={span => (this.odometer = span)}>
          {from}
        </span>
        {suffix && suffix}
      </h3>
    );
  }
}

const CardRelated = ({ insight, processInsightLink }) => {
  return (
    <CardCounterWrapper>
      <CardCounterRow>
        {insight.link1 && (
          <Fragment>
            {insight.link1Icon && <CardCounterIcon icon={insight.link1Icon} />}
            <CardCounterDetail>
              <h3
                className="font--regular font--md fg--white mb--0"
                style={{ width: "100%" }}
              >
                <a href={processInsightLink(insight.link1)} className="fg--white">
                  {insight.link1Title}
                </a>
              </h3>
            </CardCounterDetail>
          </Fragment>
        )}
      </CardCounterRow>
      <CardCounterRow>
        {insight.link2 && (
          <Fragment>
            {insight.link2Icon && <CardCounterIcon icon={insight.link2Icon} />}
            <CardCounterDetail>
              <h3
                className="font--regular font--md fg--white mb--0"
                style={{ width: "100%" }}
              >
                <a href={processInsightLink(insight.link2)} className="fg--white">
                  {insight.link2Title}
                </a>
              </h3>
            </CardCounterDetail>
          </Fragment>
        )}
      </CardCounterRow>
    </CardCounterWrapper>
  );
};

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${SIZES.sizeMd};
  border: 1px solid ${COLOURS.midGrey};
  background-color: ${COLOURS.white};
  transition: width 0.25s ease;
`;

const CardCounterRow = styled.div`
  display: flex;
`;

const CardCounterDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  padding-left: ${SIZES.sizeRg};

  a:hover {
    color: ${COLOURS.yellow};
  }
`;

const CardTitle = styled.h2`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding: ${SIZES.sizeSm} ${SIZES.sizeRg};
  font-size: ${SIZES.sizeRg};
`;

const CardImage = styled.a`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 260px;
  background-size: cover;
  background-position: center;
`;

const IframeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 260px;
  background-size: cover;
  background-position: center;
`;

const IframeSummaryContainer = styled.div`
  width: 50%;
  padding-left: 1.125rem;
  padding-right: 1.125rem;
`;

const CardIFrame = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 260px;
`;

const CardCounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-around;
  min-height: 260px;
  padding: ${SIZES.sizeRg} ${SIZES.sizeMd};
  background-color: ${COLOURS.darkBlueA};
`;

const CardSummary = styled.div`
  padding: 0 ${SIZES.sizeRg};
  font-size: ${SIZES.sizeSm};
`;

const CardBase = styled.div`
  display: flex;
  align-items: center;
  padding: ${SIZES.sizeSm} ${SIZES.sizeRg};
`;

const CardTag = styled.div`
  margin-right: ${SIZES.sizeRg};
  padding: 0.2rem ${SIZES.sizeRg};
  border-radius: 5px;
  background-color: ${COLOURS.darkBlueA};
  color: ${COLOURS.white};
  text-transform: uppercase;
  font-size: 0.75rem;
`;

const CardDate = styled.div`
  margin-right: ${SIZES.sizeRg};
  font-size: 0.8rem;
`;

export default Card;



// WEBPACK FOOTER //
// ./src/cardListing/components/Card.js